import { render, staticRenderFns } from "./_Loading.vue?vue&type=template&id=a4c47eaa&"
import script from "./_Loading.vue?vue&type=script&lang=js&"
export * from "./_Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports